import script from "./ProductsView.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProductsView.vue?vue&type=script&lang=ts&setup=true"

import "./ProductsView.vue?vue&type=style&index=0&id=6fea6479&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fea6479"]])

export default __exports__